module.exports = __webpack_public_path__ + "img/Diagnostics.8e9d3e0.png";